import { h } from 'preact'
import FirebaseComponent from './FirebaseComponent'
import { listenForFirebaseItems } from './firebase-helpers'
import { daysToDate } from './date-helpers'
import { map, pipe, values, sort, keys } from 'ramda'
import moment from 'moment'
import * as firebase from 'firebase'

import './RotasTable.css'

class RotasTable extends FirebaseComponent {
  constructor() {
    super()

    this.state.rotas = {}
    this.getTableBody = this.getTableBody.bind(this)
    this.getTableRow = this.getTableRow.bind(this)
    this.removeRotaAndShifts = this.removeRotaAndShifts.bind(this)
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        listenForFirebaseItems('rotas', rotas => {
          this.setState({ rotas })
        })
      }
    })
  }

  removeRotaAndShifts(rota) {
    const shiftIds = keys(rota.shifts)
    shiftIds.forEach(shiftId => {
      firebase.database().ref(`accounts/${this.state.uid}/shifts/${shiftId}`).remove()
      firebase.database().ref(`shifts/${shiftId}`).remove()
    })
    rota.remove()
  }

  getTableRow(rota) {
    const formatedStartDate = moment(rota.startDate).format('Do MMM YYYY')
    const formatedEndDate = moment(rota.endDate).format('Do MMM YYYY')
    return (
      <tr>
        <td>{formatedStartDate}</td>
        <td>{formatedEndDate}</td>
        <td>{rota.pattern}</td>
        <td><a onClick={() => this.removeRotaAndShifts(rota)}><i className="fa fa-trash-o"></i></a></td>
      </tr>
    )
  }

  getTableBody() {
    const byEndDates = (a, b) => daysToDate(a.endDate) - daysToDate(b.endDate)
    const rotaRows = pipe(
      values,
      sort(byEndDates),
      map(this.getTableRow)
    )(this.state.rotas)

    return (
      <tbody>
        {rotaRows}
      </tbody>
    )
  }

  render() {
    return (
			<table className="table table-hover table-striped width-full">
				<thead className="competencies-table-head">
					<tr>
						<th>Start</th>
						<th>End</th>
						<th>Pattern</th>
            <th></th>
					</tr>
				</thead>
        {this.getTableBody()}
			</table>
    )
  }
}

export default RotasTable



// WEBPACK FOOTER //
// ./src/RotasTable.js